import { EnvironmentProviders, inject, Injector, isDevMode, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, tap } from 'rxjs';

import { FeatureFlagsService } from '../feature-flags';

import { GoogleAnalyticsConfig, GoogleAnalyticsService } from './google-analytics.service';

export function provideGoogleAnalytics(config?: GoogleAnalyticsConfig): EnvironmentProviders[] {
  if (!config?.defaultId) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      const featureFlagsService = inject(FeatureFlagsService);
      const googleAnalyticsService = inject(GoogleAnalyticsService);
      const injector = inject(Injector);

      return toObservable(featureFlagsService.initialized, { injector }).pipe(
        filter((initialized) => initialized),
        tap(() => {
          if (featureFlagsService.isEnabled('fvdr-altair-ga-enabled') && !isDevMode()) {
            googleAnalyticsService.configure(config);
            googleAnalyticsService.activateDefault();
          }
        }),
        take(1),
      );
    }),
  ];
}
